<template>
  <v-data-table :headers="headers" :items="roles" sort-by="calories" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Role</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialogEditRole" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="4"
                    sm="6"
                    md="4"
                    v-for="(permission,index) in permissions"
                    v-bind:key="index"
                    style="padding:0;"
                  >
                    <v-checkbox
                      :label="permission.name"
                      :value="permission.id"
                      v-model="selectedPermissions"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddRole" max-width="500px">
          <!-- <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Role</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeAddRole">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="addRole">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.permissions`]="{ item }">
      <v-chip class="ma-2" label color="primary">{{ item.permissions.length}}</v-chip>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      <span class="text-center">No data available.</span>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { slice, orderBy } from "lodash";
export default {
  data: () => ({
    dialogEditRole: false,
    dialogAddRole: false,
    loading: false,
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "Total Permission", value: "permissions" },
      { text: "Actions", value: "action", sortable: false }
    ],
    roles: [],
    selectedRole: {},
    permissions: [],
    selectedPermissions: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      role: {
        id: ""
      }
    },
    example: [],
    verifyUser: {
      id: "",
      role_id: ""
    },
    defaultItem: {
      name: "",
      role: {
        id: ""
      }
    }
  }),

  computed: {
    ...mapGetters({
      getRoles: "role_permission/getRoles",
      getPermissions: "role_permission/getPermissions"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "Set Permission to Role" : "Edit Role";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      setPermissionToRole: "role_permission/setPermissionToRole"
    }),
    log(item) {
      //console.log(this.selectedPermissions)
    },
    async initialize() {
      this.loading = true;
      const getRoles = await this.getRoles;
      const getPermissions = await this.getPermissions;

      this.roles = orderBy(getRoles, ["id"], ["asc"]);
      this.permissions = getPermissions;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      //this.loading = false
    },
    close() {
      this.dialogEditRole = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    closeAddRole() {
      this.dialogAddRole = false;
    },
    editItem(item) {
      this.selectedPermissions = item.permissions.map(perm => perm.id);
      this.selectedRole = item;
      this.editedIndex = this.permissions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEditRole = true;
    },
    async save() {
      const payload = {
        roleId: this.selectedRole.id,
        permission: String(this.selectedPermissions)
      };
      const rolesIndex = this.roles.findIndex(
        role => role.id === this.selectedRole.id
      );
      this.roles[rolesIndex].permissions = this.selectedPermissions;
      const response = await this.setPermissionToRole(payload);
      this.close();
    },
    async addRole() {
      // console.log("add roled")
    }
  }
};
</script>